import { HARC_TUR_TANIM_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const harcTurTanimLists = () => {
    const data = {};
    return getRequest({url:HARC_TUR_TANIM_LISTESI,data});
}

export default harcTurTanimLists;